/**
 * 產品識別字串（瀏覽器頁籤、未來的 manifest / 信件標題共用）。
 *
 * 模板原本把頁籤寫死成「{路徑} | Borex - React Admin & Dashboard Template」，
 * 於是頁籤長成「Dck/assets/hardware | Borex …」——路徑不是給人看的，
 * 產品名也不是模板名。頁籤一律用 <b>頁面標題｜DC Keeper</b>，
 * 頁面標題來源就是 topbar 那個（uiStore.pageTitle，由 usePageTitle 發佈）。
 */
export const APP_NAME = "DC Keeper";

/** 沒有頁面標題時（登入頁、載入中）的頁籤字樣。 */
export const APP_TITLE = "DC Keeper 機房資產管理系統";

/** 組頁籤字串：有頁面標題就「標題｜DC Keeper」，否則用完整產品名。 */
export const documentTitleOf = (pageTitle) =>
  pageTitle ? `${pageTitle}｜${APP_NAME}` : APP_TITLE;
